
import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details"

// IMPORT UTILITIES
import { get_user_profile } from "@/router";
const details = brand_details();
export default {
  name: "PortfolioSidebar",

  // REGISTER SHARED COMPONENTS
  components: ({
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  }),

  // PROPS PASSED FROM dashboard_one
  props: {
    tiles: Array,
    current_active_property: String,
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      //Brand Information
      brand_name:details.name,
      brand_subtitle:details.subtitle,
      entity_name: details.sub_entity_name,

      // CONTEXT STATE
      selected_portfolio: details.sub_entity_name,
      local_active_property: null,
      active_menu_item: "executive-summary",
      dropdownOpen: false,
      show_collapsed_properties: false,

      // FOOTER DATA
      full_name: "Guest User",
      initials: "GU",

      // BRAND LOGO
      short_logo: details.logo
    });
  },

  // COMPUTED VALUES
  computed: ({
    tilesFormatted() {
      return (this.tiles || []).map(t => ({
        id: t.id,
        label: t.title,
        icon: t.icon || "bi bi-building" // fallback icon
      }));
    },

    menuItems() {
      return [
        { key: "executive-summary", label: "Executive Summary", icon: "bi bi-pie-chart-fill" },
      ];
    }
  }),

  // LIFECYCLE
  mounted() {
    this.load_user_name();

    if (this.current_active_property) {
      this.local_active_property = this.current_active_property;
      this.selected_portfolio = this.current_active_property;
    }
  },

  // METHODS
  methods: {
    /** FOOTER NAME / INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();

      this.full_name = name;
      this.initials = initials || "GU";
    },

    /** CONTEXT DROPDOWN ACTIONS */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    select_global_portfolio() {
      this.selected_portfolio = "Global Portfolio";
      this.local_active_property = null;
      this.active_menu_item = "executive-summary";
      this.dropdownOpen = false;

      this.$emit("global-selected");
      this.$emit("global-menu-selected", "executive-summary");
    },

    select_tile_directly(tile) {
      this.selected_portfolio = tile.label;
      this.local_active_property = tile.label;
      this.active_menu_item = "executive-summary";
      this.dropdownOpen = false;

      this.$emit("tile-clicked", tile.id);

      this.$emit("property-menu-selected", {
        menuItem: "executive-summary",
        propertyId: tile.id,
        propertyName: tile.label
      });
    },

    /** MENU SELECTION */
    select_menu_item(menuItem) {
      this.active_menu_item = menuItem;
      this.dropdownOpen = false;

      if (!this.local_active_property) {
        this.$emit("global-menu-selected", menuItem);
        return;
      }

      const tile = this.tiles.find(t => t.title === this.local_active_property);

      if (tile) {
        this.$emit("property-menu-selected", {
          menuItem,
          propertyId: tile.id,
          propertyName: tile.title
        });
      } else {
        this.$emit("global-menu-selected", menuItem);
      }
    },

    is_section_active(section) {
      if (!section.children) return false;
      return section.children.some(child => child.key === this.active_menu_item);
    },

    toggleCollapsedProperties() {
      this.show_collapsed_properties = !this.show_collapsed_properties;
    }

  }
};
